

import { normalizeProcedimientoCode } from "../../helpers/procedimientoCodeMapper";

const dataConsentimiento = (codProcedimiento, descripcion = "") => {
  const code = normalizeProcedimientoCode(codProcedimiento, descripcion);

  let colposcopias = ['57420', '57421', '57452', '57454', '57455', '57456', '57460', '57461']
  let alveloplastia = '41874'
  let end_biradicular = '200015'
  let end_mulradicular = '200020'
  let end_uniradicular = '200010'
  let frenectomia = '40819'
  let operculo = '41821'
  let desvital = '200333'
  let rehabil = '200468'
  let exodoncias = ['200050', '200055', '200060']

  if (colposcopias.find(item => item === code)) {
    return {
      tipoAtencion      : 'a',
      descripcion       : "ESTE PROCEDIMIENTO PERMITE VISUALIZAR POSIBLES LESIONES SOSPECHOSAS Y TOMAR UNA MUESTRA PEQUEÑA (BIOPSIA) PARA POSTERIORMENTE SER ANALIZADA POR UN ANATOMOPATOLOGO",
      realizacion       : "ES UN EXAMEN DEL CUELLO DEL UTERO, VAGINA Y VULVA, SIMILAR A LA TOMA DE CITOLOGIA. CERVICOVAGINA L(PAP), DONDE SE REALIZA OBSERVACION CON UN MICROSCOPIO ESPECIAL QUE PERMITE VISUALIZAR LOS CAMBIOS OCURRIDOS EN EL CUELLO DE UTERO Y VULVA",
      rutaImg           : 'imagenesProcedimientos/img-colposcopia.jpg',
      duracion          : '30 a 60 MINS',
      beneficios        : "PREVENCION DEL CANCER CERVICAL Y DIAGNOSTICO DE LESIONES EXTERNAS",
      riesgosFrecuentes : "SANGRADO Y DOLOR DURANTE EL PROCEDIMIENTO, MOLESTIAS PRODUCIDAS POR LAS SOLUCIONES APLICADAS, CALAMBRES, HORMIGUEO O LEVE DOLOR, SANGRADO MINIMO DURANTE VARIOS DIAS",
      riesgosGraves     : "HEMORRAGIA",
      alternativas      : "NO REALIZAR EL PROCEDIMIENTO",
      manejoPosterior   : "EVITAR ACTIVIDAD FISICA, EVITAR RELACIONES SEXUALES POR 15 DIAS",
      consecuencias     : "PROGRESION A CANCER DE CUELLO UTERINO Y EXTENSION DE CONDILOMATOSIS VULVAR",
      tipoAnestesia     : "x"
    }
  } 
  else if (code === alveloplastia) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "RECULARIZACION DE REBORDES OSEOS",
      realizacion       : "ANESTESIA INFILTRATIVA, . TRONCULAR . TIEMPOS OPERATORIOS",
      rutaImg           : '/imagenesConsentimiento/ALVEOLOPLASTIA.jpg',
      duracion          : '30 a 60 MINS',
      beneficios        : "ELIMINAR DOLOR . PREVENIR IVIAL OCLUSION ELIMINAR PROCESO INFECCIOSOS",
      riesgosFrecuentes : "HEMORRAGIA",
      riesgosGraves     : "OCK ANAFILACTICO . HEMORRACIA . COMUNICACION BUCO SINUSAL . FRACTURA OSEA FACIAL . ANGINA DE LUDWIG . PARESTESIA LINGUAL . FRACTURA DE TABLA OSEA",
      alternativas      : "REMITIR A ESPECIALISTA SEGUN CORRESPONDA",
      manejoPosterior   : "EVITAR ACTIVIDAD FISICA, EVITAR RELACIONES SEXUALES POR 15 DIAS",
      consecuencias     : "lNFECCION . MALOCLuSION . DOLOR . PERDIDA OSEA .ENFERMEDAD PERIODONTALES ETC.",
      tipoAnestesia     : "x"
    }
  }  
    else if (code === end_biradicular) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "RATAMIENTO DE CANALES RADICULARES",
      realizacion       : "ANESTESIA INFILTRATIVA . AISLAIVIIENTO ABSOLUTO . RETIRO DE CARIES . ACCESO CAMERAL .LOCALIZACION DE CONDUCTOS . lRRIGAcloN . CONDUCTOMETRIA . PREPARACION QUIMICOMECANICA DE CONDUCTOS . OBTURACION.",
      rutaImg           : '/imagenesConsentimiento/Endodoncia bi y multirradicular.jpg',
      duracion          : '60 MINS',
      beneficios        : "ELIMINAR DOLOR . PERSISTENCIA DE PIEZA EN LA FUNCION MASTICATORIA",
      riesgosFrecuentes : "DOLOR POSTOPERATORIO . AGUDIZACION . CONTAMINACION DEL TRATAMINETO DE CONDUCTO : SI NO SE RESTAURA DEFINITIVAMENTE LA PIEZA DENTARIA DENTRO DEL MENOR TIEMPO POSIBLE . APARECER 0 AUMENTAR LOS SINTOMAS DEL PROCES0 INFECCIOSO . APARICION Y/O AUMENTO DEL",
      riesgosGraves     : "FRACTURA DE INSTRUMENTOS . PERFORACION DENTARIA . FRACTURA DENTARIA .EXODONCIA . ACCIDENTE CON HIPOCLOR.TO DE SODIO EXTRAVASACION DE MATERIAL DE OBTURACION",
      alternativas      : "CIRUGIA BUCAL . APICECTOMIA . BLANQUEAMIENTO DENTAL INTERNO . RETRATAMIENTO",
      manejoPosterior   : "RESTAURACION DEFINITIVA: SELLE DEL TRATAMIENTO DE CONDUCTO EN EL MENOR TIEMPO POSIBLE(15 DIAS DEL PERIOD0 RECOMENDABLE) . REHABILITACION ORAL: CORONA METAL PORCELANA ,lNCRUSTACIONES ,ETC",
      consecuencias     : ".CONTAMINACI0N DEL TRATAMIENT0 DE CONDuCTO LO QUE LLEVARIA A UN RETRATAMIENTO, Y AGUDIZACION DE SINTOMATOLOGIA . FRACTURA DENTARIA : SI NO SE RESTAURA LA PIEZA DENTARIA APARCION DE FISURA DENTARIA DISCROMIA",
      tipoAnestesia     : "x"
    }
  } 
   else if (code === end_biradicular || code === end_mulradicular || code === end_uniradicular) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "TRATAMIENTO DE CANALES RADICULARES",
      realizacion       : "ANESTESIA INFILTRATIVA . AISLAIVIIENTO ABSOLUTO . RETIRO DE CARIES . ACCESO CAMERAL .LOCALIZACION DE CONDUCTOS . lRRIGAcloN . CONDUCTOMETRIA . PREPARACION QUIMICOMECANICA DE CONDUCTOS . OBTURACION.",
      rutaImg           : '/imagenesConsentimiento/Endodoncia bi y multirradicular.jpg',
      duracion          : '60 MINS',
      beneficios        : "ELIMINAR DOLOR . PERSISTENCIA DE PIEZA EN LA FUNCION MASTICATORIA",
      riesgosFrecuentes : "DOLOR POSTOPERATORIO . AGUDIZACION . CONTAMINACION DEL TRATAMINETO DE CONDUCTO : SI NO SE RESTAURA DEFINITIVAMENTE LA PIEZA DENTARIA DENTRO DEL MENOR TIEMPO POSIBLE . APARECER 0 AUMENTAR LOS SINTOMAS DEL PROCES0 INFECCIOSO . APARICION Y/O AUMENTO DEL",
      riesgosGraves     : "FRACTURA DE INSTRUMENTOS . PERFORACION DENTARIA . FRACTURA DENTARIA .EXODONCIA . ACCIDENTE CON HIPOCLOR.TO DE SODIO EXTRAVASACION DE MATERIAL DE OBTURACION",
      alternativas      : "CIRUGIA BUCAL . APICECTOMIA . BLANQUEAMIENTO DENTAL INTERNO . RETRATAMIENTO",
      manejoPosterior   : "RESTAURACION DEFINITIVA: SELLE DEL TRATAMIENTO DE CONDUCTO EN EL MENOR TIEMPO POSIBLE(15 DIAS DEL PERIOD0 RECOMENDABLE) . REHABILITACION ORAL: CORONA METAL PORCELANA ,lNCRUSTACIONES ,ETC",
      consecuencias     : ".CONTAMINACI0N DEL TRATAMIENT0 DE CONDuCTO LO QUE LLEVARIA A UN RETRATAMIENTO, Y AGUDIZACION DE SINTOMATOLOGIA . FRACTURA DENTARIA : SI NO SE RESTAURA LA PIEZA DENTARIA APARCION DE FISURA DENTARIA DISCROMIA",
      tipoAnestesia     : "x"
    }
  } 
    else if (code === frenectomia) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "SE HACE UNA PEQUERA INCISION EN EL PLIEGUE MUCOSA EN UNION DEL LABIO CON MAXILAR",
      realizacion       : "ANESTESIA INFILTRATIVA, TRONCULAR, SINDESMOTOMIA, TIEMPOS OPERATORIO",
      rutaImg           : '/imagenesConsentimiento/frenectomia.jpg',
      duracion          : '30 MINS',
      beneficios        : "ELIMINAR DIASTEMA",
      riesgosFrecuentes : "DOLOR, lNFLAMACION, SANGRADO, lNFECCION , HEMATOMAS, SANACION RETARDADA, CICATRIZ",
      riesgosGraves     : "SHOCK ANAFILACTICO, HEMORRAGIA, LESION DE NERVIO, PERDIDA DE SENSIBILIDAD, ENTUMECIMIENTO",
      alternativas      : "REMITIR A ESPECIALISTA SECuN CORRESPONDA",
      manejoPosterior   : "USO DE ANALCESICOS . ANTIINFLAMATORIOS EN CASO NECESARIO CONTROLES RADIOGRAFICOS",
      consecuencias     : "DIASTEMAS, PROBLEMAS DE FONACION",
      tipoAnestesia     : "x"
    }
  } 
    else if (code === operculo) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "EXPOSICION DEL ORGANO DENTAL OBSTACULIZANDO EN Su ERUPCION",
      realizacion       : "ANESTESIA INFILTRATIVA, TRONCULAR, SINDESMOTOMIA, TIEMPOS OPERATORIO",
      rutaImg           : '/imagenesConsentimiento/OPERCULECTOMIA.jpg',
      duracion          : '30 a 60 MINS',
      beneficios        : "ELIMINAR DOLOR . PREVENIR MAL OCLUSION ELIMINAR PROCESO INFECCIOSOS",
      riesgosFrecuentes : "HEMORRAGIA",
      riesgosGraves     : "SHOCK ANAFILACTICO . HEMORRAGIA . PARESTESIS LABIAL . COMUNICACION BuCOSINUSAL . FRACTURA OSEA FACIAL . ANGINA DE LUDWIG . PARESTESIA LINCUAL . FRACTURA DE TABLA OSEA",
      alternativas      : "REMITIR A ESPECIALISTA SECuN CORRESPONDA",
      manejoPosterior   : "USO DE ANALCESICOS . ANTIINFLAMATORIOS EN CASO NECESARIO CONTROLES RADIOGRAFICOS",
      consecuencias     : "APINAMIENTOS . INFECCION . MALOCLuSION . DOLOR .PERDIDA OSEA . ENFERIVIEDAD PERIODONTALES ETC",
      tipoAnestesia     : "x"
    }
  } 
   else if (exodoncias.find(item => item === code)) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "EXTRAER LA PIEZA DENTAL DEL ALVEOLO",
      realizacion       : "ANESTESIA INFILTRATIVA, TRONCULAR, SINDESMOTOMIA, TIEMPOS OPERATORIO",
      rutaImg           : '/imagenesConsentimiento/imagenes para  exodoncias.jpg',
      duracion          : '30 A 60 MINS',
      beneficios        : "ELIMINAR EL DOLOR, ELIMINAR PROCESOS INFECCIOSOS, PREVENIR MAL OCLUSION ",
      riesgosFrecuentes : "• ALVEOLITIS • HEMORRAGIA • FRACTURA RADICULAR",
      riesgosGraves     : "• SHOCK ANAFILACTICO • HEMORRAGIA • PARESTESIS LABIAL • COMUNICACION BUCOSINUSAL • FRACTURA OSEA FACIAL • ANGINA DE LUDWIG • PARESTESIA LINGUAL • FRACTURA DE TABLA OSEA ",
      alternativas      : "REMITIR A ESPECIALISTA SECuN CORRESPONDA",
      manejoPosterior   : "• USO DE ANALGÉSICOS • ANTIINFLAMATORIOS EN CASO NECESARIO CONTROLES RADIOGRAFICOS",
      consecuencias     : "• APIÑAMIENTOS • INFECCION • MALOCLUSION • DOLOR •PERDIDA OSEA • ENFERMEDAD PERIODONTALES ETC",
      tipoAnestesia     : "x"
    }
  } 
  else if (code === desvital) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "DESVITALIZACION Y MOMIFICAcloN DE PULPA CAMERAL",
      realizacion       : ": ANESTESIA INFILTRATIVA, AISLAMIENTO ABSOLUTO, RETIRO DE CARIES, ACCESO Y CONFORMACION CAMERAL, MOMIFICACION, OBTURACION.",
      rutaImg           : '/imagenesConsentimiento/desvitalizacion y momificación.jpg',
      duracion          : '30 MINS',
      beneficios        : "ELIMINAR DOLOR . PERSISTENCIA DE PIEZA EN LA FUNCION MASTICATORIA",
      riesgosFrecuentes : "DOLOR POST-OPERATORIO, AGUDIZACION, CONTAMINACION, APARECER 0, AUMENTAR LOS SINTOMAS DEL PROCESO INFECCIOSO, APARICION Y/O AUMENTO DEL DOLOR",
      riesgosGraves     : "PERFORACION DENTARIA, FRACTURA DENTARIA, EXODONCIA",
      alternativas      : "CIRUGIA BUCAL",
      manejoPosterior   : "RESTAURACION DEFINITIVA: SELLE DEL TRATAMIENTO EN EL MENOR TIEMPO POSIBLE (15 DIAS DEL PERIODO RECOMENDABLE), REHABILITACION ORAL",
      consecuencias     : "CONTAMINACION, FRACTURAMIENTO DENTARIO",
      tipoAnestesia     : "x"
    }
  } 
   else if (code === rehabil) {
     return {
      tipoAtencion      : 'a',
      descripcion       : "CEMENTACIÓN DE CORONA PROVISIONAL DE ACRÍLICO",
      realizacion       : "EXAMEN RADIOGRÁFICO. EVALUACIÓN CLÍNICA. FABRICACIÓN DE LA CORONA ACRÍLICA Y CEMENTADO.",
      rutaImg           : '/imagenesConsentimiento/CORONA-CEMENTACION DE CORONA.jpg',
      duracion          : '45 a 60 MINS',
      beneficios        : "APORTAR RETENCIÓN A LA RECONSTRUCCIÓN DE LA PIEZA, GARANTIZA LA DURABILIDAD DE LA PIEZA SEMIDESTRUIDA, DOTA DE RESISTENCIA A LA PIEZA ENDODONCIADA, PROTECCIÓN DE MUÑÓN PROTÉSICO, DEVOLVER FUNCIÓN MASTICATORIA",
      riesgosFrecuentes : "CARIES EXTENSA, TRAUMA OCLUSAL",
      riesgosGraves     : "FRACTURA DE LA CORONO PROVISIONAL, FRACTURA DENTAL",
      alternativas      : "NINGUNO",
      manejoPosterior   : "CUIDADOS ALIMENTICIOS, CEMENTACIÓN DE CORONA FIJA METAL PORCELANA, RELACIONADO CON LA PIEZA DENTAL, COMO UNA FRACTURA DENTAL O DESPRENDIMIENTO DE LA CORONA PROVISIONAL, ESTA CORONA PROVISIONAL TIENE LA POSIBILIDAD DE REEMPLAZAR EL DIENTE POR UN PERÍODO DE 1 MES",
      consecuencias     : "CARIES DENTAL, SI EN CASO NO SE REALIZA LA CORONA PROVISIONAL LA PIEZA PUEDE CONTAMINARSE, FRACTURARSE O SUFRIR OTRO TIPO DE COMPLICACIÓN, QUE PUDIERA HACER NECESARIO REHACER EL TRATAMIENTO ENDODÓNTICO, O INCLUSO LA EXTRACCIÓN DE LA PIEZA DENTARIA",
      tipoAnestesia     : "x"
    }
  }
  else {


  
  return {
    ambulatoria       : true,
    descripcion       : "",
    realizacion       : "",
    rutaImg           : '',
    duracion          : '',
    beneficios        : "",
    riesgosFrecuentes : "",
    riesgosGraves     : "",
    alternativas      : "",
    manejoPosterior   : "",
    consecuencias     : "",
    tipoAnestesia     : "x"
  }
  }
    
};

export const infoDataConsentimiento = {
  dataConsentimiento,
};
